module.exports = __webpack_public_path__ + "static/media/icon_close.39cee2b5.svg";